import { ref, nextTick, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-476d5a4f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "filter-list-content"
};
const _hoisted_3 = {
  class: "input-select-content"
};
const _hoisted_4 = {
  class: "filter-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "产品名", -1));
const _hoisted_6 = {
  class: "appListPopover-content"
};
const _hoisted_7 = {
  class: "appListPopover-content-title"
};
const _hoisted_8 = {
  class: "inf-label"
};
const _hoisted_9 = {
  class: "inf-value"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_11 = {
  class: "filter-list"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "渠道", -1));
const _hoisted_13 = {
  class: "filter-list"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "商品类型", -1));
const _hoisted_15 = {
  class: "filter-list"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "商品信息", -1));
const _hoisted_17 = {
  class: "filter-list"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "商品状态", -1));
const _hoisted_19 = {
  class: "filter-list-content"
};
const _hoisted_20 = {
  class: "input-select-content"
};
const _hoisted_21 = {
  class: "filter-list"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "时间", -1));
const _hoisted_23 = {
  class: "btn-content"
};
import { onMounted } from '@vue/runtime-core';
import { getNode, detailFields, searchFields, getAppListInformation, copy } from '@/common';
// import useGetSelect from '@/hooks/useGetSelect'
import { getProdTypeByDbtId } from '@/api/goodsInfo';
import { useAppDimensionStore } from '@/store/appDimension';
import { message } from 'ant-design-vue';
// import {  getProdTypeByDbtId } from '@/api/goodsJudge'
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'GoodInfoFilterBlock',
  emits: ['filterSubmit', 'setProductName', 'emptyTable'],
  setup(__props, {
    emit
  }) {
    const appDimensionStore = useAppDimensionStore();
    // const { dbtProducts, getDbtProducts, getChnlOptions,
    //   chnlOptions,
    // } = useGetSelect('apple')
    const typeList = [{
      label: '全部',
      value: ''
    }, {
      label: '消耗型',
      value: '20'
    }, {
      label: '非消耗型',
      value: '10'
    }, {
      label: '非自动续期订阅',
      value: '31'
    }, {
      label: '自动续期订阅',
      value: '32'
    }]; // 商品类型下拉框
    const productSelectRef = ref(null);
    const dbtProducts = ref([]);
    const dbtId = ref(''); // 产品名
    const infoType = ref(''); // 商品类型
    const fuzzy = ref(''); // 产品名
    const prodStatus = ref(''); // 商品状态
    const timeRangeType = ref('sync');
    const timeRangeValue = ref();
    const filterOptions = [{
      label: '全部',
      value: ''
    }, {
      label: '有效',
      value: '10'
    }, {
      label: '失效',
      value: '20'
    }];
    // 添加预设时间范围
    const rangePresets = ref([{
      label: '今日',
      value: [dayjs().startOf('day'), dayjs().endOf('day')]
    }, {
      label: '昨日',
      value: [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')]
    }, {
      label: '最近7天',
      value: [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')]
    }, {
      label: '最近30天',
      value: [dayjs().subtract(29, 'day').startOf('day'), dayjs().endOf('day')]
    }]);
    const channelList = ref([]); // 渠道列表
    const channel = ref(null); // 渠道
    // 变更选择的产品
    const changeDbtId = async e => {
      dbtId.value = e;
      // 查询渠道列表
      await getChannelList();
    };
    // 获取产品下拉
    const getDbtProducts = async () => {
      var _productSelectRef$val;
      dbtProducts.value = appDimensionStore.goodsInfoProducts;
      await nextTick();
      (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(dbtProducts.value);
    };
    // 搜索
    const filterSubmit = () => {
      // 根据timeRangeType判断sync-商品同步时间publishTimeStart/End judge-最近上传时间submitTimeStart/End
      const params = {
        fuzzy: fuzzy.value,
        dbtId: dbtId.value,
        approvalStatuses: [30],
        prodType: infoType.value,
        prodChnl: channel.value,
        prodStatus: prodStatus.value,
        publishStatuses: [10]
      };
      // 仅当 timeRangeValue 是有效数组时才处理
      if (Array.isArray(timeRangeValue.value) && timeRangeValue.value.length === 2) {
        const [start, end] = timeRangeValue.value;
        if (timeRangeType.value === 'sync') {
          params.publishTimeStart = dayjs(start).format('YYYY-MM-DD HH:mm:ss');
          params.publishTimeEnd = dayjs(end).format('YYYY-MM-DD HH:mm:ss');
        } else if (timeRangeType.value === 'judge') {
          params.approvalSyncTimeStart = dayjs(start).format('YYYY-MM-DD HH:mm:ss');
          params.approvalSyncTimeEnd = dayjs(end).format('YYYY-MM-DD HH:mm:ss');
        }
      }
      emit('filterSubmit', params);
    };
    // 初始化
    const init = async () => {
      fuzzy.value = '';
      infoType.value = '';
      prodStatus.value = '';
      timeRangeType.value = 'sync';
      timeRangeValue.value = undefined;
      await getDbtProducts();
    };
    // 获取渠道列表
    const getChannelList = async () => {
      if (!dbtId.value) return;
      channelList.value = [];
      channel.value = null;
      try {
        const {
          data,
          code
        } = await getProdTypeByDbtId({
          dbtId: dbtId.value
        });
        if (code == '0') {
          var _data$prodChnl;
          channelList.value = (_data$prodChnl = data.prodChnl) === null || _data$prodChnl === void 0 ? void 0 : _data$prodChnl.filter(item => ['apple', 'harmony'].includes(item.channelCode)).map(item => ({
            label: item.channelName,
            value: item.channelCode
          }));
          if (channelList.value.length) {
            channel.value = channelList.value[0].value;
            // 调用审核信息查询接口
            filterSubmit();
          } else {
            channel.value = null;
            message.warning('暂无可支持配置渠道');
            emit('emptyTable');
          }
        } else {
          emit('emptyTable');
        }
      } catch (e) {}
    }; // 获取渠道列表
    const goodsInfoMounted = ref(false);
    const goodsInfoInitialized = ref(false);
    const initializeGoodsInfoPage = async () => {
      if (!goodsInfoMounted.value || !appDimensionStore.goodsInfoLoaded || goodsInfoInitialized.value) return;
      goodsInfoInitialized.value = true;
      fuzzy.value = '';
      infoType.value = '';
      await getDbtProducts();
      if (dbtProducts.value.length) {
        dbtId.value = dbtProducts.value[0].value;
        await getChannelList();
      }
    };
    watch(() => appDimensionStore.goodsInfoLoaded, () => {
      initializeGoodsInfoPage();
    });
    onMounted(async () => {
      goodsInfoMounted.value = true;
      await initializeGoodsInfoPage();
    });
    return (_ctx, _cache) => {
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_unref(ProductSelect), {
        ref_key: "productSelectRef",
        ref: productSelectRef,
        modelValue: dbtId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dbtId.value = $event),
        multiple: false,
        "show-extra": true,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": true,
        "allow-clear": false,
        layout: "vertical",
        descriptionField: "filePath",
        width: 200,
        "popup-class-name": "vertical-product-select",
        placeholder: "请选择",
        detailFields: _unref(detailFields),
        onChange: changeDbtId,
        "show-bottom-border": ""
      }, {
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_8, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_9, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_10]),
            default: _withCtx(() => [_createVNode(_component_SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue", "search-fields", "detailFields"])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_a_select, {
        value: channel.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => channel.value = $event),
        placeholder: "请选择",
        "get-popup-container": _unref(getNode),
        options: channelList.value,
        onChange: filterSubmit
      }, null, 8, ["value", "get-popup-container", "options"])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_a_select, {
        onChange: filterSubmit,
        value: infoType.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => infoType.value = $event),
        placeholder: "请选择",
        options: typeList,
        "get-popup-container": _unref(getNode)
      }, null, 8, ["value", "get-popup-container"])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_a_input, {
        allowClear: "",
        value: fuzzy.value,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => fuzzy.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入内购ID/商品名称"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_a_select, {
        value: prodStatus.value,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => prodStatus.value = $event),
        placeholder: "请选择",
        options: filterOptions
      }, null, 8, ["value"])])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createVNode(_component_a_select, {
        ref: "select",
        value: timeRangeType.value,
        "onUpdate:value": _cache[5] || (_cache[5] = $event => timeRangeType.value = $event),
        style: {
          "width": "132px"
        },
        placeholder: "请选择"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_select_option, {
          value: "sync"
        }, {
          default: _withCtx(() => [_createTextVNode("最近同步时间")]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "judge"
        }, {
          default: _withCtx(() => [_createTextVNode("最近上传时间")]),
          _: 1
        })]),
        _: 1
      }, 8, ["value"]), _createVNode(_component_a_range_picker, {
        value: timeRangeValue.value,
        "onUpdate:value": _cache[6] || (_cache[6] = $event => timeRangeValue.value = $event),
        "show-time": "",
        presets: rangePresets.value,
        style: {
          "width": "340px"
        }
      }, null, 8, ["value", "presets"])])]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_a_button, {
        onClick: init
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});